import React, { useState, useEffect } from 'react';
import { FaClock, FaUserTie, FaSlidersH } from 'react-icons/fa';
import { db } from '../../firebase';
import { addDoc, collection, getDocs, Timestamp } from 'firebase/firestore';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Label,
} from '@headlessui/react';
import { CalendarDaysIcon, UserCircleIcon, TruckIcon } from '@heroicons/react/20/solid';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { UserIcon } from '@heroicons/react/16/solid';
import {
  AdjustmentsHorizontalIcon,
  ArrowUpRightIcon,
  BriefcaseIcon,
  GlobeAltIcon,
  HeartIcon,
  MapIcon,
  MapPinIcon,
  ShoppingBagIcon,
} from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { CheckIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import AutoCompleteInput from '../../components/AutocompleteInput';
//import { BookingProvider } from '../../context/BookingContext';
//import { BookingBar } from '../../components/BookingBar';
import { BookingDialog } from '../../components/BookingBar';

const vehicles = [
  {
    id: 'e-class',
    name: 'Mercedes Classe E',
    imageUrl: '/img/Gemini_Generated_Image_ui6qchui6qchui6q.png',
  },
  {
    id: 'v-class',
    name: 'Mercedes Classe V',
    imageUrl: '/img/Gemini_Generated_Image_rqk97hrqk97hrqk9.png',
  },
  {
    id: 's-class',
    name: 'Mercedes Classe S',
    imageUrl: '/img/Gemini_Generated_Image_2j2ojj2j2ojj2j2o.png',
  },
  {
    id: 'sprinter',
    name: 'Mercedes Sprinter',
    imageUrl: '/img/Gemini_Generated_Image_tw9r5ftw9r5ftw9r.png',
  },
  // More users...
];

const features = [
  {
    name: 'Disponibilità 24/7',
    description:
      'Siamo operativi ogni giorno, a qualsiasi ora. Prenota il tuo trasferimento in ogni momento, anche con breve preavviso.',
    href: '/',
    icon: <FaClock className="mb-4 text-4xl text-primary" />,
  },
  {
    name: 'Autisti professionisti',
    description:
      'Personale qualificato, puntuale e sempre cortese. Massima discrezione e conoscenza del territorio.',
    href: '/',
    icon: <FaUserTie className="mb-4 text-4xl text-primary" />,
  },
  {
    name: 'Servizio personalizzato',
    description:
      'Scegli il tipo di veicolo, il percorso o eventuali fermate. Adattiamo ogni viaggio alle tue esigenze.',
    href: '/',
    icon: <FaSlidersH className="mb-4 text-4xl text-primary" />,
  },
];

function RightServices() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:ml-auto lg:pl-4 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="hidden text-base/7 font-semibold text-indigo-600">Deploy faster</h2>
              <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Trasferimenti e servizi professionali
              </p>
              <p className="mt-6 hidden text-lg/8 text-gray-600">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit
                perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
                {[
                  {
                    name: 'Trasferimenti da e per aeroporti',
                    description: 'Collegamenti puntuali con tutti gli aeroporti del nord Italia.',
                    icon: ArrowUpRightIcon,
                  },
                  {
                    name: 'Trasferimenti aziendali e meeting',
                    description: 'Comfort e puntualità per i tuoi spostamenti professionali.',
                    icon: BriefcaseIcon,
                  },
                  {
                    name: 'Viaggi su lunghe distanze',
                    description: 'Raggiungi qualsiasi destinazione con comodità e sicurezza.',
                    icon: MapPinIcon,
                  },
                  {
                    name: 'Servizi personalizzati',
                    description: 'Organizziamo soluzioni su misura per ogni tipo di esigenza.',
                    icon: AdjustmentsHorizontalIcon,
                  },
                ].map(feature => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        aria-hidden="true"
                        className="absolute left-1 top-1 size-5 text-primary"
                      />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
              <div className="mt-8">
                <Link
                  to="/servizi"
                  className="inline-flex rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  Scopri di più
                </Link>
              </div>
            </div>
          </div>
          <div className="flex items-start justify-end lg:order-first">
            <img
              alt="Product screenshot"
              src="/img/1761502975562_crop.jpg"
              width={2432}
              height={1442}
              className="w-[48rem] max-w-xl rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            />
            <img
              alt="Product screenshot"
              src="/img/1761502975562_crop.jpg"
              width={2432}
              height={1442}
              className="hidden w-[48rem] max-w-xl rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function LeftServices() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start">
          <div className="lg:pr-4 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="hidden text-base/7 font-semibold text-indigo-600">Deploy faster</h2>
              <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Turismo, eventi e tempo libero
              </p>
              <p className="mt-6 hidden text-lg/8 text-gray-700">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit
                perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
                {[
                  {
                    name: 'Matrimoni ed eventi speciali',
                    description: 'Servizi eleganti per accompagnare i tuoi momenti più importanti.',
                    icon: HeartIcon,
                  },
                  {
                    name: 'Visite guidate in Franciacorta',
                    description: 'Tour personalizzati tra cantine e paesaggi della Franciacorta.',
                    icon: MapIcon,
                  },
                  {
                    name: 'Outlet Village',
                    description: 'Shopping senza pensieri con trasporto privato da e per l’outlet.',
                    icon: ShoppingBagIcon,
                  },
                  {
                    name: 'NCC per turismo e tempo libero',
                    description: 'Spostati senza stress durante le tue vacanze o weekend.',
                    icon: GlobeAltIcon,
                  },
                ].map(feature => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        aria-hidden="true"
                        className="absolute left-1 top-1 size-5 text-primary"
                      />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
              <div className="mt-8">
                <Link
                  to="/servizi"
                  className="inline-flex rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  Scopri di più
                </Link>
              </div>
            </div>
          </div>

          <img
            alt="Product screenshot"
            src="/img/1761502852114_crop.jpg"
            width={2432}
            height={1442}
            className="w-[48rem] max-w-xl rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:ml-0"
          />
        </div>
      </div>
    </div>
  );
}

function Features() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Un servizio pensato per ogni esigenza
          </h2>
          <p className="mt-6 text-lg/8 text-gray-600">
            Affidabilità, flessibilità e professionalità sono al centro della nostra offerta. Scopri
            cosa rende NCC BRO DRIVER la scelta ideale per i tuoi spostamenti.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map(feature => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base/7 font-semibold text-gray-900">
                  {feature.icon}
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}

function Hero() {
  return (
    <div className="relative isolate overflow-hidden bg-white">
      <svg
        aria-hidden="true"
        className="absolute inset-0 -z-10 size-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
      >
        <defs>
          <pattern
            x="50%"
            y={-1}
            id="983e3e4c-de6d-4c3f-8d64-b9761d1534cc"
            width={200}
            height={200}
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none" />
          </pattern>
        </defs>
        <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
          <path
            d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
            strokeWidth={0}
          />
        </svg>
        <rect
          fill="url(#983e3e4c-de6d-4c3f-8d64-b9761d1534cc)"
          width="100%"
          height="100%"
          strokeWidth={0}
        />
      </svg>
      <div
        aria-hidden="true"
        className="absolute left-[calc(50%-4rem)] top-10 -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)]"
      >
        <div
          style={{
            clipPath:
              'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
          }}
          className="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#fff] to-[#b08d46] opacity-70"
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:flex lg:px-8 lg:py-40">
        <div className="mx-auto max-w-2xl shrink-0 lg:mx-0 lg:pt-8">
          <img
            alt="Your Company"
            src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600"
            className="hidden h-11"
          />
          <img
            alt="Your Company"
            src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=500"
            className="hidden h-11"
          />

          <h1 className="mt-10 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
            Viaggia con eleganza, comfort e totale sicurezza
          </h1>
          <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            Scopri l’esperienza premium di NCC BRO DRIVER: il nostro servizio di noleggio con
            conducente ti garantisce viaggi puntuali, rilassanti e senza stress. Che si tratti di
            trasferimenti aeroportuali, meeting di lavoro o eventi speciali, ti accompagniamo con
            stile e professionalità.
          </p>
          <div className="mt-10 flex items-center gap-x-6">
            <Link
              to="/dashboard"
              className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#9e7f3f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:hover:bg-[#9e7f3f] dark:focus-visible:outline-primary"
            >
              Accedi
            </Link>
            <Link to="/contatti" className="text-sm/6 font-semibold text-gray-900">
              Contatta <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
        <div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
          <div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
            <img
              alt="App screenshot"
              src="https://images.pexels.com/photos/5880098/pexels-photo-5880098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
              width={2432}
              height={1442}
              className="w-[76rem] rounded-md bg-gray-50 shadow-xl ring-1 ring-gray-900/10 dark:hidden"
            />
            <img
              alt="App screenshot"
              src="https://images.pexels.com/photos/5880098/pexels-photo-5880098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
              width={2432}
              height={1442}
              className="hidden w-[76rem] rounded-md bg-white/5 shadow-2xl ring-1 ring-white/10 dark:block"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function CTA() {
  return (
    <div className="bg-white">
      <div className="px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Pronto per il tuo prossimo viaggio?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-gray-600">
            Prenota ora un trasferimento NCC su misura per te, con il massimo comfort e puntualità.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/dashboard"
              className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary dark:focus-visible:outline-primary"
            >
              Calcola la tua corsa
            </Link>
            <Link to="/contatti" className="text-sm/6 font-semibold text-gray-900">
              Contatta <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Home() {
  const [locations, setLocations] = useState([]);
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [datetime, setDatetime] = useState('');

  //const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [price, setPrice] = useState(null);
  const [distance, setDistance] = useState(null);
  const [duration, setDuration] = useState({
    text: '',
    value: '',
  });

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const snapshotRoutes = await getDocs(collection(db, 'routes'));
        const locationsSet = new Set();
        snapshotRoutes.forEach(doc => {
          const data = doc.data();
          if (data.origin) locationsSet.add(data.origin);
          if (data.destination) locationsSet.add(data.destination);
        });

        setLocations(Array.from(locationsSet));
      } catch (err) {
        console.error(err);
      }
    };

    fetchEntries();
  }, []);

  const [currentStep, setCurrentStep] = React.useState(0);

  const steps = [
    { name: 'origin-destionation', href: '/', status: currentStep > 0 ? 'complete' : 'current' },
    {
      name: 'quote-estimated',
      href: '/',
      status: currentStep === 1 ? 'current' : currentStep > 1 ? 'complete' : 'upcoming',
    },
    {
      href: '/',
      name: 'contact-information',
      status: currentStep === 2 ? 'current' : currentStep > 2 ? 'complete' : 'upcoming',
    },
    {
      href: '/',
      name: 'confirmation',
      status: currentStep >= 3 ? 'complete' : 'upcoming',
    },
  ];

  const nextStep = () => setCurrentStep(prev => Math.min(prev + 1, steps.length - 1));
  const prevStep = () => setCurrentStep(prev => Math.max(prev - 1, 0));

  const calculatePrice = async e => {
    //setDistance(null);
    //setPrice(null);
    //setDuration({ text: '', value: '' });

    e.preventDefault();
    setIsWaiting(() => true);
    try {
      const res = await fetch('/.netlify/functions/get-distance-km', {
        method: 'POST',
        headers: { 'x-api-key': 'abcDEF123456789!@#' },
        body: JSON.stringify({ origin, destination, selectedVehicle }),
      });

      const data = await res.json();

      setDistance(() => data.distance.value / 1000);
      //const calculatedPrice = calculatePrice(data.distance.value / 1000).toFixed(2);
      setPrice(() => data.price);
      setDuration(() => data.duration);
      //setIsWaiting(() => false);
      nextStep();
    } catch (err) {
      //setIsWaiting(() => false);
      console.error(err);
    } finally {
      setIsWaiting(() => false);
    }
  };

  const [errors, setErrors] = useState({
    email: '',
    firstName: '',
    lastName: '',
  });

  const validateForm = () => {
    const newErrors = {};
    const { firstName, lastName, email } = state.form;
    if (!firstName?.trim()) newErrors.firstName = 'Please fill in your first name';
    if (!lastName?.trim()) newErrors.lastName = 'Please fill in your last name';
    if (!email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Please fill in a valid email address';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    if (validateForm()) {
      e.preventDefault();
      const formData = new FormData(e.target);

      try {
        const result = await addDoc(collection(db, 'submissions'), {
          ...formData,
          origin,
          destination,
          price,
          distance,
          duration,
          datetime,
          createdAt: Timestamp.now(),
        });
        formData.set('uid', result.id);
      } catch (err) {
        console.error(err);
      } finally {
        nextStep();
        setState(s => ({ ...s, form: { ...s.form, data: formData } }));
      }

      /*fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      })
        .then(result => {
          console.debug(result);
          nextStep();
        })
        .catch(err => console.error(err));*/
    }
  };

  const [state, setState] = useState({
    form: {
      lastName: '',
      firstName: '',
      telephone: '',
      email: '',
    },
  });

  function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  }

  const handleFormChange = e => {
    setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleChange = e => {
    setState(state => ({ ...state, [e.target.name]: e.target.value }));
  };

  const [isWaiting, setIsWaiting] = useState(false);

  const getMinDateTime = () => {
    const now = new Date();
    now.setHours(now.getHours() + 12); // aggiungi 12 ore

    // Formatta in YYYY-MM-DDTHH:MM
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [query, setQuery] = React.useState('');
  const [selectedVehicle, setSelectedVehicle] = React.useState({
    id: 'e-class',
    name: 'Mercedes Classe E',
    imageUrl: '/img/Gemini_Generated_Image_ui6qchui6qchui6q.png',
  });

  const filteredVehicles =
    query === ''
      ? vehicles
      : vehicles.filter(person => {
          return person.name.toLowerCase().includes(query.toLowerCase());
        });

  return (
    <div className="text-gray-800">
      {/* Hero */}
      {false && <Hero />}
      <section className="relative flex h-screen items-center justify-center bg-black text-white">
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-60"
          style={{
            backgroundImage: `url(/img/donna-d-affari-che-sale-su-un-taxi-scaled.jpg)`,
          }}
        />

        {/* Overlay (opacità sfumata) */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Form content */}
        <div className="relative z-50 w-full px-6">
          {/*<form
            ref={formRef}
            name="quote-request"
            id="quote-request-form"
            data-netlify="true"
            method="POST"
            onSubmit={handleSubmit}
            className="bg-white bg-opacity-60 rounded-lg shadow-lg p-6 space-y-4 text-gray-800"
          >*/}
          <BookingDialog />
          <div className="hidden space-y-4 rounded-lg bg-white/60 p-6 text-gray-800 shadow-lg">
            {false && (
              <nav aria-label="Progress" className="flex items-center justify-center">
                <p className="text-sm font-medium text-gray-900">
                  Step {steps.findIndex(step => step.status === 'current') + 1} of {steps.length}
                </p>
                <ol className="ml-8 flex items-center space-x-5">
                  {steps.map(step => (
                    <li key={step.name}>
                      {step.status === 'complete' ? (
                        <a
                          href={step.href}
                          className="block size-2.5 rounded-full bg-indigo-600 hover:bg-indigo-900"
                        >
                          <span className="sr-only">{step.name}</span>
                        </a>
                      ) : step.status === 'current' ? (
                        <a
                          href={step.href}
                          aria-current="step"
                          className="relative flex items-center justify-center"
                        >
                          <span aria-hidden="true" className="absolute flex size-5 p-px">
                            <span className="size-full rounded-full bg-indigo-200" />
                          </span>
                          <span
                            aria-hidden="true"
                            className="relative block size-2.5 rounded-full bg-indigo-600"
                          />
                          <span className="sr-only">{step.name}</span>
                        </a>
                      ) : (
                        <a
                          href={step.href}
                          className="block size-2.5 rounded-full bg-gray-200 hover:bg-gray-400"
                        >
                          <span className="sr-only">{step.name}</span>
                        </a>
                      )}
                    </li>
                  ))}
                </ol>
              </nav>
            )}

            <h1 className="mb-8 text-center text-3xl font-bold md:text-4xl">
              Stima il costo del tuo viaggio
            </h1>

            <nav aria-label="Progress" className="hidden">
              <ol className="flex items-center justify-center">
                {steps.slice(0, 3).map((step, stepIdx) => (
                  <li
                    key={step.name}
                    className={classNames(
                      stepIdx !== steps.length - 2 ? 'pr-8 sm:pr-20' : '',
                      'relative'
                    )}
                  >
                    {step.status === 'complete' ? (
                      <>
                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                          <div className="h-0.5 w-full bg-primary" />
                        </div>
                        <a
                          href="/"
                          className="relative flex size-8 items-center justify-center rounded-full bg-primary hover:bg-primary"
                        >
                          <CheckIcon aria-hidden="true" className="size-5 text-white" />
                          <span className="sr-only">{step.name}</span>
                        </a>
                      </>
                    ) : step.status === 'current' ? (
                      <>
                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                          <div className="h-0.5 w-full bg-gray-200" />
                        </div>
                        <a
                          href="/"
                          aria-current="step"
                          className="relative flex size-8 items-center justify-center rounded-full border-2 border-primary bg-white"
                        >
                          <span aria-hidden="true" className="size-2.5 rounded-full bg-primary" />
                          <span className="sr-only">{step.name}</span>
                        </a>
                      </>
                    ) : (
                      <>
                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                          <div className="h-0.5 w-full bg-gray-200" />
                        </div>
                        <a
                          href="/"
                          className="group relative flex size-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400"
                        >
                          <span
                            aria-hidden="true"
                            className="size-2.5 rounded-full bg-transparent group-hover:bg-gray-300"
                          />
                          <span className="sr-only">{step.name}</span>
                        </a>
                      </>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
            {/*<BookingProvider
              initialData={{
                from: origin,
                to: destination,
                datetime: datetime,
                estimatedPrice: price,
              }}
            >
              <BookingDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
            </BookingProvider>*/}
            {false && currentStep === 0 && (
              <div className="grid grid-cols-1 gap-4">
                <form
                  //ref={formRef}
                  name="quote-request"
                  id="quote-request-form"
                  data-netlify="true"
                  method="POST"
                  data-netlify-honeypot="bot-field"
                  onSubmit={() => {
                    calculatePrice();
                    //setIsDialogOpen(() => true);
                  }}
                >
                  <input type="hidden" name="form-name" value="quote-request" />
                  <p hidden>
                    <label>
                      Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                    </label>
                  </p>
                  <div data-netlify-recaptcha="true"></div>
                  <AutoCompleteInput
                    label="Partenza"
                    name="origin"
                    placeholder="Inserisci la partenza"
                    value={origin}
                    onChange={setOrigin}
                    options={locations}
                  />
                  <div>
                    <label
                      htmlFor="datetime"
                      className="mb-1 block text-sm font-medium text-gray-900"
                    >
                      Giorno e ora
                    </label>
                    <input
                      type="datetime-local"
                      name="datetime"
                      value={datetime}
                      onChange={e => setDatetime(e.target.value)}
                      id="datetime"
                      min={getMinDateTime()}
                      className="w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:border-primary focus:ring-primary"
                      required
                    />
                  </div>
                  <AutoCompleteInput
                    label="Destinazione"
                    name="destination"
                    placeholder="Inserisci la destinazione"
                    value={destination}
                    onChange={setDestination}
                    options={locations}
                  />
                  {false && (
                    <Combobox
                      as="div"
                      value={selectedVehicle}
                      onChange={vehicle => {
                        setQuery('');
                        setSelectedVehicle(() => vehicle);
                      }}
                    >
                      <Label
                        htmlFor="combo-vehicle"
                        className="mb-1 block text-sm font-medium text-gray-900"
                      >
                        Auto
                      </Label>

                      <div className="relative mt-2">
                        <ComboboxInput
                          className="block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
                          onChange={event => setQuery(event.target.value)}
                          onBlur={() => setQuery('')}
                          displayValue={vehicle => vehicle?.name}
                          name="combo-vehicle"
                          id="combo-vehicle"
                        />
                        <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                          <ChevronDownIcon className="size-5 text-gray-400" aria-hidden="true" />
                        </ComboboxButton>

                        <ComboboxOptions
                          transition
                          className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                        >
                          {query.length > 0 && (
                            <ComboboxOption
                              value={{ id: null, name: query }}
                              className="cursor-default select-none px-3 py-2 text-gray-900 data-[focus]:bg-primary data-[focus]:text-white data-[focus]:outline-none"
                            >
                              <div className="flex items-center">
                                <div className="grid size-6 shrink-0 place-items-center rounded-full bg-gray-300 [[data-focus]_&]:bg-white">
                                  <UserIcon
                                    className="size-4 fill-white [[data-focus]_&]:fill-primary"
                                    aria-hidden="true"
                                  />
                                </div>
                                <span className="ml-3 block truncate">{query}</span>
                              </div>
                            </ComboboxOption>
                          )}
                          {filteredVehicles.map(vehicle => (
                            <ComboboxOption
                              key={vehicle.id}
                              value={vehicle}
                              className="cursor-default select-none px-3 py-2 text-gray-900 data-[focus]:bg-primary data-[focus]:text-white data-[focus]:outline-none"
                            >
                              <div className="flex items-center">
                                <img
                                  src={vehicle.imageUrl}
                                  alt=""
                                  className="size-6 shrink-0 rounded-full bg-gray-100 outline outline-1 -outline-offset-1 outline-black/5"
                                />
                                <span className="ml-3 block truncate">{vehicle.name}</span>
                              </div>
                            </ComboboxOption>
                          ))}
                        </ComboboxOptions>
                      </div>
                    </Combobox>
                  )}
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={prevStep}
                      disabled={currentStep === 0}
                      className={classNames(
                        'hidden px-4 py-2 rounded-md text-sm font-medium',
                        currentStep === 0
                          ? 'bg-gray-200 text-gray-400'
                          : 'bg-gray-300 hover:bg-gray-400 text-gray-800'
                      )}
                    >
                      Indietro
                    </button>
                    <button
                      id="calculate-price"
                      type="submit"
                      className={`rounded-md bg-primary px-4 py-2 text-sm font-medium text-white ${
                        isWaiting ? 'cursor-not-allowed' : 'hover:bg-primary'
                      }`}
                    >
                      {isWaiting ? (
                        <span className="flex items-center gap-2">
                          <svg
                            className="size-5 animate-spin text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                            />
                          </svg>
                          In corso...
                        </span>
                      ) : (
                        'Avanti'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {false && currentStep === 1 && (
              <form
                name="contacts-quote"
                id="contacts-quote-form"
                data-netlify="true"
                method="POST"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="form-name" value="contacts-quote" />
                {/*<input type="text" name="uid" hidden />*/}
                <div data-netlify-recaptcha="true"></div>
                <div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2">
                  <div>
                    <label
                      htmlFor="first-name"
                      className="block text-sm/6 font-semibold text-gray-900"
                    >
                      Nome
                    </label>
                    <div className="mt-2.5">
                      <input
                        required
                        id="first-name"
                        name="firstName"
                        type="text"
                        placeholder="Mario"
                        value={state.form.firstName}
                        onChange={handleFormChange}
                        autoComplete="given-name"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                      />
                      <div>
                        {errors.firstName && (
                          <p className="text-sm text-red-500">{errors.firstName}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="last-name"
                      className="block text-sm/6 font-semibold text-gray-900"
                    >
                      Cognome
                    </label>
                    <div className="mt-2.5">
                      <input
                        required
                        id="last-name"
                        name="lastName"
                        value={state.form.lastName}
                        onChange={handleFormChange}
                        placeholder="Rossi"
                        type="text"
                        autoComplete="family-name"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                      />
                      <div>
                        {errors.lastName && (
                          <p className="text-sm text-red-500">{errors.lastName}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
                      Email
                    </label>
                    <div className="mt-2.5">
                      <input
                        id="email"
                        name="email"
                        required
                        value={state.form.email}
                        placeholder="mario.rossi@email.com"
                        onChange={handleFormChange}
                        type="email"
                        autoComplete="email"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                      />
                      <div>
                        {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label
                      htmlFor="telephone"
                      className="block text-sm/6 font-semibold text-gray-900"
                    >
                      Cellulare
                    </label>
                    <div className="mt-2.5">
                      <input
                        id="telephone"
                        name="telephone"
                        required
                        placeholder="+39 123 456 7890"
                        value={state.form.telephone}
                        onChange={handleFormChange}
                        type="tel"
                        autoComplete="tel"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-6 flex justify-between">
                  <button
                    type="button"
                    onClick={prevStep}
                    disabled={currentStep === 0}
                    className={classNames(
                      'px-4 py-2 rounded-md text-sm font-medium',
                      currentStep === 0
                        ? 'bg-gray-200 text-gray-400'
                        : 'bg-gray-300 hover:bg-gray-400 text-gray-800'
                    )}
                  >
                    Indietro
                  </button>
                  <button
                    id="contacts-quote-form-submit-button"
                    type="submit"
                    className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary"
                  >
                    Avanti
                  </button>
                </div>
              </form>
            )}
            {false && currentStep === 2 && (
              <>
                <div className="lg:col-start-3 lg:row-end-1">
                  <h2 className="sr-only">Summary</h2>
                  <div className="rounded-lg bg-gray-50 shadow-sm outline outline-1 outline-gray-900/5">
                    <dl className="flex flex-wrap">
                      <div className="flex-auto pl-6 pt-6">
                        <dt className="text-sm/6 font-semibold text-gray-900">Prezzo</dt>
                        <dd className="mt-1 text-base font-semibold text-gray-900">EUR {price}</dd>
                      </div>
                      {false && (
                        <div className="flex-none self-end px-6 pt-4">
                          <dt className="sr-only">Status</dt>
                          <dd className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                            Paid
                          </dd>
                        </div>
                      )}
                      <div className="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                        <dt className="flex-none">
                          <span className="sr-only">Client</span>
                          <UserCircleIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                        </dt>
                        <dd className="text-sm/6 font-medium text-gray-900">{`${state.form.firstName} ${state.form.lastName}`}</dd>
                      </div>
                      {/* Start Location */}
                      <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
                        <dt className="flex-none">
                          <span className="sr-only">Start Location</span>
                          <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                        </dt>
                        <dd className="text-sm/6 text-gray-500">{origin}</dd>
                      </div>
                      {/* End Location */}
                      <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
                        <dt className="flex-none">
                          <span className="sr-only">Destination Location</span>
                          <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                        </dt>
                        <dd className="text-sm/6 text-gray-500">{destination}</dd>
                      </div>
                      <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
                        <dt className="flex-none">
                          <span className="sr-only">Due date</span>
                          <CalendarDaysIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                        </dt>
                        <dd className="text-sm/6 text-gray-500">
                          <time
                            dateTime={datetime}
                            //dateTime={datetime.split('T').at(0)}
                          >
                            {new Date(datetime).toLocaleString('it-IT', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                            })}
                          </time>
                        </dd>
                      </div>

                      {/* Car Model */}
                      <div className="mb-6 mt-4 flex w-full flex-none gap-x-4 px-6">
                        <dt className="flex-none">
                          <span className="sr-only">Car Model</span>
                          <TruckIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                        </dt>
                        <dd className="text-sm/6 text-gray-500">
                          {vehicles.find(item => item.id === selectedVehicle.id).name}
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
                {false && (
                  <div className="grid grid-cols-1 gap-px bg-gray-900/5 lg:grid-cols-3">
                    {[
                      { name: 'Distanza', value: distance, unit: 'km' },
                      {
                        name: 'Prezzo',
                        value: price,
                        unit: 'EUR',
                      },
                      {
                        name: 'Durata',
                        value: duration?.text,
                        unit: '',
                      },
                    ].map(stat => (
                      <div
                        key={stat.name}
                        className="items-center justify-center bg-transparent px-4 py-6 sm:px-6 lg:px-8"
                      >
                        <p className="text-sm/6 font-medium text-gray-500">{stat.name}</p>
                        <p className="mt-2 flex items-baseline gap-x-2">
                          <span className="text-4xl font-semibold tracking-tight text-gray-900">
                            {stat.value}
                          </span>
                          {stat.unit ? (
                            <span className="text-sm text-gray-500">{stat.unit}</span>
                          ) : null}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
                <div className="mt-6 flex justify-between">
                  <button
                    type="button"
                    onClick={prevStep}
                    disabled={currentStep === 0}
                    className={classNames(
                      'px-4 py-2 rounded-md text-sm font-medium',
                      currentStep === 0
                        ? 'bg-gray-200 text-gray-400'
                        : 'bg-gray-300 hover:bg-gray-400 text-gray-800'
                    )}
                  >
                    Indietro
                  </button>
                  <button
                    id="confirm-button"
                    type="button"
                    onClick={() => {
                      fetch('/', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: encode({
                          'form-name': 'contact',
                          firstName: state.form.firstName,
                          lastName: state.form.lastName,
                          email: state.form.email,
                          telephone: state.form.telephone,
                          datetime: new Date(datetime).toLocaleString('it-IT', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          }),
                          service: selectedVehicle.name,
                          message: `prezzo: ${price}, partenza: ${origin}, destinazione: ${destination}`,
                        }), //new URLSearchParams(state.form.data).toString(),
                      })
                        .then(result => {
                          console.debug(result);
                          nextStep();
                        })
                        .catch(err => console.error(err));
                    }}
                    className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary"
                  >
                    Conferma
                  </button>
                </div>
              </>
            )}
            {false && currentStep === 3 && (
              <>
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <h3 className="text-base font-semibold text-gray-900">Inviato</h3>
                    <div className="mt-2">
                      <p className="text-sm text-black">
                        La tua richiesta di preventivo è stata inviata.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 flex justify-center sm:mt-6">
                  <button
                    type="button"
                    onClick={async () => {
                      setOrigin('');
                      setDestination('');
                      setDatetime('');
                      setDistance(null);
                      setPrice(null);
                      setCurrentStep(0);
                    }}
                    className="inline-flex justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                  >
                    Chiudi
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      {false && (
        <section className="relative bg-gray-900 text-white">
          {/* Immagine di sfondo professionale */}
          <img
            src="https://images.pexels.com/photos/5880098/pexels-photo-5880098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
            alt="Limousine in città di notte"
            className="absolute inset-0 size-full object-cover opacity-60"
          />

          {/* Overlay semi-trasparente per miglior contrasto */}
          <div className="absolute inset-0 bg-black opacity-40"></div>

          {/* Contenuti sopra l’overlay */}
          <div className="relative z-10 mx-auto max-w-3xl px-4 py-24 text-center">
            <h1 className="mb-4 text-4xl font-bold sm:text-5xl">
              NCC Milano e Brescia — Il tuo viaggio con stile e puntualità
            </h1>
            <p className="mb-6 text-lg">
              Prenota il tuo trasferimento con autista privato. Disponibile 24/7 per aeroporti,
              eventi e viaggi business.
            </p>
            <Link
              to="/dashboard"
              className="inline-block rounded border border-white px-6 py-3 text-lg text-white transition hover:bg-white hover:text-gray-900"
            >
              Calcola il Prezzo
            </Link>
          </div>
        </section>
      )}
      <Features />
      <form className="group/tiers bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 sm:max-w-2xl sm:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none">
            {[
              {
                imageUrl: '/img/Gemini_Generated_Image_ckibldckibldckib_2_crop.png',
                name: 'Mercedes-Benz E-Class',
                id: 'tier-freelancer',
                href: '#',
                price: { monthly: '$29', annually: '$299' },
                description:
                  'La Mercedes-Benz E-Class è la berlina ideale per chi desidera un servizio di noleggio con conducente che unisca eleganza e praticità. \
                Grazie al suo design raffinato e agli interni curati, ogni spostamento si trasforma in un’esperienza di lusso.  \
                I sistemi di sicurezza avanzati assicurano massima serenità durante il viaggio. Scegli la E-Class per trasferimenti aziendali o occasioni speciali e regala ai tuoi clienti un’esperienza di viaggio memorabile.',
                features: ['3 Passeggeri', '2 Bagagli a mano', '2 Valigie'],
                featured: false,
              },
              {
                imageUrl: '/img/Gemini_Generated_Image_ckibldckibldckib_1_crop.png',
                name: 'Mercedes-Benz V-Class',
                id: 'tier-hobby',
                href: '#',
                price: { monthly: '$19', annually: '$199' },
                description:
                  'La Mercedes-Benz V-Class è la soluzione perfetta per gruppi e famiglie, grazie allo spazio generoso e al comfort elevato che offre. Con una capienza fino a 7 passeggeri, \
                questa monovolume si presta a trasferimenti aziendali, tour personalizzati ed eventi di ogni tipo. Gli interni eleganti, con sedute ergonomiche e tecnologie di bordo moderne, \
                garantiscono un viaggio piacevole e rilassante. Scegliere la V-Class significa offrire un servizio che unisce stile e praticità, assicurando a ogni passeggero un’esperienza di viaggio confortevole.',
                features: ['6/7 Passeggeri', '6 Bagagli a mano', '6 Valigie'],
                featured: false,
              },
              {
                imageUrl: '/img/Gemini_Generated_Image_ckibldckibldckib_3_crop.png',
                name: 'Mercedes-Benz S-Class',
                id: 'tier-startup',
                href: '#',
                price: { monthly: '$59', annually: '$599' },
                description:
                  'La Mercedes-Benz S-Class rappresenta il massimo del lusso nel settore del noleggio con conducente. \
                Questa elegante berlina, caratterizzata da un design raffinato e da interni di altissimo livello, \
                assicura un’esperienza di viaggio superiore. Grazie alle tecnologie più moderne, come il sistema MBUX, \
                e ai dispositivi di sicurezza avanzati, \
                la S-Class offre comfort e protezione eccellenti. Ideale per trasferimenti prestigiosi e eventi speciali, \
                è la scelta perfetta per garantire ai tuoi clienti un servizio esclusivo e memorabile.',
                features: ['3 Passeggeri', '2 Bagagli a mano', '2 Valigie'],
                featured: true,
              },
              {
                imageUrl: '/img/Gemini_Generated_Image_ckibldckibldckib_4_crop.png',
                name: 'Mercedes Sprinter',
                id: 'tier-enterprise',
                href: '#',
                price: { monthly: '$99', annually: '$999' },
                description:
                  'Perfetto per spostamenti di gruppi fino a 19 partecipanti. Che si tratti di una trasferta di lavoro, di una celebrazione particolare o di un viaggio per eventi familiari, \
                i nostri minibus rappresentano la scelta ideale per offrire comodità e tranquillità durante il tragitto.',
                features: ['19 Passeggeri', '19 Bagagli a mano', '19 Valigie'],
                featured: false,
              },
            ].map(tier => (
              <div
                key={tier.id}
                data-featured={tier.featured ? 'true' : undefined}
                className="group/tier rounded-3xl p-8 ring-1 ring-gray-200 data-[featured]:ring-2 data-[featured]:ring-primary"
              >
                <div className="mb-6 flex items-center justify-between gap-x-4">
                  <h3
                    id={`tier-${tier.id}`}
                    className="text-lg/8 font-semibold text-gray-900 group-data-[featured]/tier:text-primary"
                  >
                    {tier.name}
                  </h3>
                </div>
                <div className="relative w-full">
                  <img
                    alt=""
                    src={tier.imageUrl}
                    className="w-full rounded-2xl bg-gray-100 object-cover object-bottom md:object-center lg:object-bottom"
                  />
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                </div>
                <p className="mt-4 text-sm/6 text-gray-600">{tier.description}</p>
                <p className="mt-6 flex items-baseline gap-x-1 group-[:not(:has([name=frequency][value=monthly]:checked))]/tiers:hidden">
                  <span className="text-4xl font-semibold tracking-tight text-gray-900">
                    {tier.price.monthly}
                  </span>
                  <span className="text-sm/6 font-semibold text-gray-600">/month</span>
                </p>
                <p className="mt-6 flex items-baseline gap-x-1 group-[:not(:has([name=frequency][value=annually]:checked))]/tiers:hidden">
                  <span className="text-4xl font-semibold tracking-tight text-gray-900">
                    {tier.price.annually}
                  </span>
                  <span className="text-sm/6 font-semibold text-gray-600">/year</span>
                </p>
                <a
                  href={tier.href}
                  aria-describedby={tier.id}
                  className="mt-6 hidden w-full rounded-md px-3 py-2 text-center text-sm/6 font-semibold text-indigo-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 group-data-[featured]/tier:bg-indigo-600 group-data-[featured]/tier:text-white group-data-[featured]/tier:shadow-sm group-data-[featured]/tier:ring-0 group-data-[featured]/tier:hover:bg-indigo-500"
                >
                  Buy plan
                </a>
                <ul className="mt-8 space-y-3 text-sm/6 text-gray-600">
                  {tier.features.map(feature => (
                    <li key={feature} className="flex gap-x-3">
                      <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </form>

      {false && (
        <section className="bg-white px-4 py-16">
          <div className="mx-auto max-w-5xl text-center">
            <h2 className="mb-10 text-3xl font-bold">I nostri punti di forza</h2>
            <div className="grid gap-8 text-left md:grid-cols-3">
              <div className="rounded bg-gray-50 p-6 shadow">
                <FaClock className="mb-4 text-4xl text-blue-600" />
                <h3 className="mb-2 text-xl font-semibold">Disponibilità 24/7</h3>
                <p>
                  Siamo operativi ogni giorno, a qualsiasi ora. Prenota il tuo trasferimento in ogni
                  momento, anche con breve preavviso.
                </p>
              </div>

              <div className="rounded bg-gray-50 p-6 shadow">
                <FaUserTie className="mb-4 text-4xl text-blue-600" />
                <h3 className="mb-2 text-xl font-semibold">Autisti professionisti</h3>
                <p>
                  Personale qualificato, puntuale e sempre cortese. Massima discrezione e conoscenza
                  del territorio.
                </p>
              </div>

              <div className="rounded bg-gray-50 p-6 shadow">
                <FaSlidersH className="mb-4 text-4xl text-blue-600" />
                <h3 className="mb-2 text-xl font-semibold">Servizio personalizzato</h3>
                <p>
                  Scegli il tipo di veicolo, il percorso o eventuali fermate. Adattiamo ogni viaggio
                  alle tue esigenze.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* CTA finale 
            <section className="py-12 bg-blue-600 text-white text-center">
                <h2 className="text-3xl font-semibold mb-4">Prenota ora il tuo viaggio con NCC</h2>
                <Link
                    to="/dashboard"
                    className="bg-white text-blue-600 font-semibold px-6 py-3 rounded shadow hover:bg-gray-100 transition"
                >
                    Vai al Calcolo Prezzo
                </Link>
            </section>*/}

      {false && (
        <section className="bg-white px-4 py-16">
          <div className="mx-auto grid max-w-6xl items-center gap-8 md:grid-cols-2">
            <div>
              <img
                src="/img/elegante-super-autista-che-fa-un-giro-taxi.jpg"
                alt="Auto NCC Mercedes di lusso"
                className="h-auto w-full rounded shadow"
              />
            </div>

            <div>
              <h2 className="mb-4 text-3xl font-bold text-gray-900">Noleggio con conducente</h2>
              <p className="mb-4 text-gray-700">
                <strong>NCC BRO DRIVER</strong> ti offre un’esperienza di viaggio speciale con il
                nostro servizio di noleggio con conducente.
              </p>
              <p className="mb-4 text-gray-700">
                I nostri autisti esperti ti accompagneranno in modo sicuro e professionale,
                garantendo che tu arrivi a destinazione in tutta tranquillità.
              </p>
              <p className="mb-4 text-gray-700">
                Con auto di lusso e un’impeccabile attenzione ai dettagli, ti offriamo un viaggio
                confortevole ed elegante, perfetto per trasferimenti da e per l’aeroporto, tour
                turistici o incontri di lavoro.
              </p>
              <p className="mb-4 text-gray-700">
                Prenotare è facile: puoi farlo comodamente attraverso il nostro sito web o
                contattandoci al numero <strong>+39 351 363 1080</strong>.
              </p>
              <p className="mb-8 text-gray-700">
                Siamo qui per rendere il tuo viaggio memorabile e su misura per le tue esigenze.
              </p>

              {/* CTA Button */}
              <Link
                to="/dashboard"
                className="inline-block rounded border border-gray-900 px-6 py-3 text-lg text-gray-900 transition hover:bg-gray-900 hover:text-white"
              >
                Prenota ora
              </Link>
            </div>
          </div>
        </section>
      )}

      <div className="hidden bg-white py-24 sm:py-32">
        <div className="relative isolate">
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-2xl flex-col gap-16 bg-white/75 px-6 py-16 shadow-lg ring-1 ring-gray-900/5 sm:rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-20 xl:gap-x-20 xl:px-20">
              <img
                alt=""
                src="/img/Gemini_Generated_Image_wlnnhkwlnnhkwlnn.png"
                className="h-96 w-full flex-none rounded-2xl object-cover lg:h-auto lg:max-w-sm"
              />
              <div className="w-full flex-auto">
                <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">
                  Il Miglior servizio NCC per le Olimpiadi Milano Cortina 2026
                </h2>
                <p className="mt-6 text-pretty text-lg/8 text-gray-600">
                  Offriamo trasferimenti esclusivi e personalizzati da Verona e Milano verso tutte
                  le principali località olimpiche, garantendo comfort, puntualità e sicurezza.
                </p>
                <ul className="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base/7 text-gray-950 sm:grid-cols-2">
                  {[].map(benefit => (
                    <li key={benefit} className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="h-7 w-5 flex-none text-indigo-500"
                      />
                      {benefit}
                    </li>
                  ))}
                </ul>
                <div className="mt-10 flex">
                  <a
                    href="/contatti"
                    className="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-300"
                  >
                    Prenota ora il Tuo transfer NCC per le Olimpiadi 2026
                    <span aria-hidden="true">&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            aria-hidden="true"
            className="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
          >
            <div
              style={{
                clipPath:
                  'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
              }}
              className="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#9fd6fc] to-[#8680fd] opacity-50"
            />
          </div>
        </div>
      </div>

      <RightServices />
      <LeftServices />
      {false && (
        <section className="bg-gray-100 px-4 py-16">
          <div className="mx-auto max-w-6xl text-center">
            <h2 className="mb-10 text-3xl font-bold text-gray-900">I nostri servizi</h2>

            <div className="grid grid-cols-1 gap-6 text-left sm:grid-cols-2 lg:grid-cols-4">
              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  Trasferimenti da e per aeroporti
                </h3>
                <p className="text-sm text-gray-700">
                  Collegamenti puntuali con tutti gli aeroporti del nord Italia.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  Matrimoni ed eventi speciali
                </h3>
                <p className="text-sm text-gray-700">
                  Servizi eleganti per accompagnare i tuoi momenti più importanti.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  Visite guidate in Franciacorta
                </h3>
                <p className="text-sm text-gray-700">
                  Tour personalizzati tra cantine e paesaggi della Franciacorta.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  Trasferimenti aziendali e meeting
                </h3>
                <p className="text-sm text-gray-700">
                  Comfort e puntualità per i tuoi spostamenti professionali.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  Viaggi su lunghe distanze
                </h3>
                <p className="text-sm text-gray-700">
                  Raggiungi qualsiasi destinazione con comodità e sicurezza.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">Outlet Village</h3>
                <p className="text-sm text-gray-700">
                  Shopping senza pensieri con trasporto privato da e per l’outlet.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">
                  NCC per turismo e tempo libero
                </h3>
                <p className="text-sm text-gray-700">
                  Spostati senza stress durante le tue vacanze o weekend.
                </p>
              </div>

              <div className="rounded bg-white p-5 shadow transition hover:shadow-md">
                <h3 className="mb-2 text-lg font-semibold text-blue-800">Servizi personalizzati</h3>
                <p className="text-sm text-gray-700">
                  Organizziamo soluzioni su misura per ogni tipo di esigenza.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      <CTA />

      {false && (
        <section className="relative mt-16 bg-gray-900 text-white">
          {/* Immagine di sfondo 
                <img
                    src="https://images.pexels.com/photos/8040985/pexels-photo-8040985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                    alt="Strada di notte"
                    className="absolute inset-0 w-full h-full object-cover opacity-60"
                />*/}
          {/* Overlay */}
          <div className="absolute inset-0 bg-black opacity-40"></div>

          {/* Contenuto */}
          <div className="relative z-10 mx-auto max-w-3xl px-4 py-20 text-center">
            <h2 className="mb-4 text-3xl font-bold sm:text-4xl">
              Pronto per il tuo prossimo viaggio?
            </h2>
            <p className="mb-6 text-lg">
              Prenota ora un trasferimento NCC su misura per te, con il massimo comfort e
              puntualità.
            </p>
            <Link
              to="/dashboard"
              className="inline-block rounded border border-white px-6 py-3 text-lg text-white transition hover:bg-white hover:text-gray-900"
            >
              Calcola il Prezzo
            </Link>
          </div>
        </section>
      )}
    </div>
  );
}
